import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { motion } from 'framer-motion';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const PolygonToolSidebar = (props: Props): JSX.Element => {
    return (
        <motion.div {...ANIMATION_APPEAR}>
            <S_PolygonToolSidebar className={props.className}>
                <SidebarContent withTopPadding>
                    <S_Message type="idea">{Localization.POLYGON_ADD2}</S_Message>
                </SidebarContent>
            </S_PolygonToolSidebar>
        </motion.div>
    );
};

const S_PolygonToolSidebar = styled.div`
    width: 100%;
`;

const S_Message = styled(Message)`
    margin: 0 0 15px 0;
`;
